// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-content-container {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: 40px;
  padding-right: 200px;
  color: #1a4e59;
  flex: 1 1;
}

.chat-content-container::-webkit-scrollbar {
  width: 6px;
}

.chat-content-container::-webkit-scrollbar-thumb {
  background-color: #a6a5a5;
  border-radius: 20px;
}

.chat-content-container::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.chat-content-container::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

.chat-content-user {
  position: relative;
  margin-top: 40px;
  padding: 18px 20px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
  text-align: justify;
}

.chat-content-references-container {
  margin-top: 30px;
  border: 1px solid #8d8d8d;
  border-radius: 10px;
  padding: 32px 24px;
  width: 800px;
  box-sizing: border-box;
}

.chatbox{
  width:45% !important;
}

.chat-content-references-header {
  font-size: 17px;
  font-weight: 700;
  color: #1886da;
}

.chat-content-refernce-sub-title {
  color: black;
  font-size: 16px;
  font-weight: 600;
  margin-top: 12px;
}

.chat-content-referencs {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.chat-content-refernce-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 8px;
}

.chat-content-reference-hierrachy {
  font-size: 16px;
  line-height: 18px;
  color: black;
}

.chat-content-reference-button-group {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px;
}

.chat-content-reference-button-group button {
  background: none;
  border: none;
  cursor: pointer;
  width: 18px;
  height: 18px;
  padding: 0px;
  border-radius: 50%;
}

.chat-content-refernce-divider {
  border-bottom: 1px solid #8d8d8d;
  margin-top: 8px;
  margin-bottom: 8px;
}

.chat-content-answer-header {
  position: relative;

  margin-right: 10px;
  margin-top: 30px;
  float: left;
  max-width: 90%;
  border: none;
  display: flex;
  flex-direction: row;

  padding-left: 10px;

  font-size: 1rem;
  line-height: 1;
}

.chat-content-source-container {
  position: relative;

  margin-right: 10px;
  margin-bottom: 30px;
  float: left;
  max-width: 90%;
  border: none;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 15px;
}

.chat-content-source {
  position: relative;

  margin-top: 3px;
  margin-bottom: 3px;

  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;

  background-color: #00000000;
  border-bottom: 1px solid #e7e7e0;
  text-decoration: none;
  color: #1a4e59;

  display: flex;

  cursor: help;

  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;

  transition: color 0.3s ease;
}

.chat-content-source-text {
  margin: 0;
  margin-right: 20px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}

.chat-content-source:hover {
  color: #3dc0c0;
}

.chat-content-source:active {
  color: rgb(182, 182, 175);
}

.chat-content-source.disabled {
  color: #d8d7d0;
}

.chat-content-source-link-icon {
  position: absolute;
  right: 1px;
  bottom: 5px;
}

.chat-content-ai {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  color: black;
}

.chat-content-ai-text {
  background: transparent;
  color: black;
  width: 800px;
  margin-top: 16px;
}

.chat-content-server-status {
  width: calc(100% - 60px);
  background-color: #ffffff00;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  margin-top: 5px;
}

.chat-content-server-status-hiding {
  width: calc(100% - 60px);
  background-color: #ffffff00;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;

  opacity: 1;
  animation: fadeOut 0.7s ease-out forwards;
}

@keyframes fadeOut {
  to {
    opacity: 0;
  }
}

.chat-content-ai-horizontal-line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 55px;
  border-top: 1px solid #b8b8b8;
}

.chat-content-gap-horizontal-line {
  position: relative;
  top: -2px;

  margin-right: 10px;
  width: calc(100% - 30px);

  border-top: 1px solid #b8b8b8;
  display: flex;
}

.chat-introduction-container {
  padding-top: 200px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 23px;
  font-weight: normal;
  color: black;
  width: 800px;
  box-sizing: border-box;
  text-align: left;
}

.chat-terms {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chat-terms-info {
  display: flex;
  gap: 46px;
}

.chat-term-item {
  padding: 20px 10px 28px 10px;
  width: 195px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #9e9e9e;
  box-sizing: border-box;
}

.chat-term-item-icon svg {
  width: 68px;
  height: 68px;
  color: #2895eb;
}

.chat-term-title {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #146eb6;
}

.chat-term-content {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
}

.chat-terms-agree {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
}

.chat-terms-agree-description {
  font-size: 16px;
  font-weight: 400;
}

.chat-terms-agree-button {
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  color: white;
  background-color: #2895eb;
  padding: 7px 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
}

.chat-terms-agree-button:hover {
  background-color: #1886da;
}

.prompt-examples-container {
  margin-top: 12px;
  width: 800px;
  box-sizing: border-box;
}

.prompt-examples-title {
  margin-top: 18px;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 700;
  color: black;
  line-height: normal;
}

.prompt-desc {
  margin-top: 30px;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  width: 800px;
  text-align: left;
}

.prompt-examples {
  display: flex;
  flex-wrap: wrap;
}

.prompt-example {
  margin-top: 10px;
  margin-right: 15px;
  border-radius: 5px;
  border: 1px solid #9e9e9e;
  background: #fff;
  display: flex;
  padding: 7px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;

  font-size: 12px;
  font-weight: 600;
  color: #146eb6;
}

.prompt-example:hover {
  background-color: #146eb6;
  color: white;
}

.chat-content-summary {
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
  color: black;
  padding: 30px 20px;
  margin-top: 20px;
  width: 800px;
  box-sizing: border-box;
}

.btn-tax-calculate {
  border-radius: 5px !important;
  border: none !important;
  cursor: pointer !important;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s !important;
  color: white !important;
  background-color: #2895eb !important;
  /* padding: 7px 20px !important; */
  /* font-size: 12px !important;
  font-weight: 600 !important;
  line-height: normal !important; */
}

.btn-tax-calculate:hover {
  background-color: #1886da !important;
  color: white !important;
}

.btn-tax-calculate span {
  color: white !important;
  margin-right: 8px;
}

.btn-tax-form-guide {
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  color: white;
  background-color: #2895eb;
  padding: 7px 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  width: -moz-fit-content;
  width: fit-content;
}

.btn-tax-form-guide:hover {
  background-color: #1886da;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/chat/Content.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;;EAEnB,kBAAkB;;EAElB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;;EAElB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;;EAEnB,2BAA2B;EAC3B,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;;EAEd,aAAa;;EAEb,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;;EAEZ,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;;EAET,kBAAkB;EAClB,wBAAwB;;EAExB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gEAAgE;EAChE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gEAAgE;;EAEhE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,2EAA2E;EAC3E,uBAAuB;EACvB,oCAAoC;EACpC,kCAAkC;EAClC;;mCAEiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gEAAgE;EAChE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".chat-content-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding-left: 40px;\n  padding-right: 200px;\n  color: #1a4e59;\n  flex: 1;\n}\n\n.chat-content-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-content-container::-webkit-scrollbar-thumb {\n  background-color: #a6a5a5;\n  border-radius: 20px;\n}\n\n.chat-content-container::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.chat-content-container::-webkit-scrollbar-corner {\n  background-color: #f1f1f1;\n}\n\n.chat-content-user {\n  position: relative;\n  margin-top: 40px;\n  padding: 18px 20px;\n  font-size: 16px;\n  font-weight: 400;\n  border-radius: 10px;\n  border: 1px solid #d9d9d9;\n  background: #fafafa;\n  text-align: justify;\n}\n\n.chat-content-references-container {\n  margin-top: 30px;\n  border: 1px solid #8d8d8d;\n  border-radius: 10px;\n  padding: 32px 24px;\n  width: 800px;\n  box-sizing: border-box;\n}\n\n.chatbox{\n  width:45% !important;\n}\n\n.chat-content-references-header {\n  font-size: 17px;\n  font-weight: 700;\n  color: #1886da;\n}\n\n.chat-content-refernce-sub-title {\n  color: black;\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 12px;\n}\n\n.chat-content-referencs {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-content-refernce-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 8px;\n}\n\n.chat-content-reference-hierrachy {\n  font-size: 16px;\n  line-height: 18px;\n  color: black;\n}\n\n.chat-content-reference-button-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 10px;\n}\n\n.chat-content-reference-button-group button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  padding: 0px;\n  border-radius: 50%;\n}\n\n.chat-content-refernce-divider {\n  border-bottom: 1px solid #8d8d8d;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.chat-content-answer-header {\n  position: relative;\n\n  margin-right: 10px;\n  margin-top: 30px;\n  float: left;\n  max-width: 90%;\n  border: none;\n  display: flex;\n  flex-direction: row;\n\n  padding-left: 10px;\n\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.chat-content-source-container {\n  position: relative;\n\n  margin-right: 10px;\n  margin-bottom: 30px;\n  float: left;\n  max-width: 90%;\n  border: none;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  padding: 15px;\n}\n\n.chat-content-source {\n  position: relative;\n\n  margin-top: 3px;\n  margin-bottom: 3px;\n\n  padding-left: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n\n  background-color: #00000000;\n  border-bottom: 1px solid #e7e7e0;\n  text-decoration: none;\n  color: #1a4e59;\n\n  display: flex;\n\n  cursor: help;\n\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n\n  transition: color 0.3s ease;\n}\n\n.chat-content-source-text {\n  margin: 0;\n  margin-right: 20px;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: none;\n}\n\n.chat-content-source:hover {\n  color: #3dc0c0;\n}\n\n.chat-content-source:active {\n  color: rgb(182, 182, 175);\n}\n\n.chat-content-source.disabled {\n  color: #d8d7d0;\n}\n\n.chat-content-source-link-icon {\n  position: absolute;\n  right: 1px;\n  bottom: 5px;\n}\n\n.chat-content-ai {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 23px;\n  color: black;\n}\n\n.chat-content-ai-text {\n  background: transparent;\n  color: black;\n  width: 800px;\n  margin-top: 16px;\n}\n\n.chat-content-server-status {\n  width: calc(100% - 60px);\n  background-color: #ffffff00;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 5px;\n  margin-top: 5px;\n}\n\n.chat-content-server-status-hiding {\n  width: calc(100% - 60px);\n  background-color: #ffffff00;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 5px;\n\n  opacity: 1;\n  animation: fadeOut 0.7s ease-out forwards;\n}\n\n@keyframes fadeOut {\n  to {\n    opacity: 0;\n  }\n}\n\n.chat-content-ai-horizontal-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 55px;\n  border-top: 1px solid #b8b8b8;\n}\n\n.chat-content-gap-horizontal-line {\n  position: relative;\n  top: -2px;\n\n  margin-right: 10px;\n  width: calc(100% - 30px);\n\n  border-top: 1px solid #b8b8b8;\n  display: flex;\n}\n\n.chat-introduction-container {\n  padding-top: 200px;\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  line-height: 23px;\n  font-weight: normal;\n  color: black;\n  width: 800px;\n  box-sizing: border-box;\n  text-align: left;\n}\n\n.chat-terms {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.chat-terms-info {\n  display: flex;\n  gap: 46px;\n}\n\n.chat-term-item {\n  padding: 20px 10px 28px 10px;\n  width: 195px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid #9e9e9e;\n  box-sizing: border-box;\n}\n\n.chat-term-item-icon svg {\n  width: 68px;\n  height: 68px;\n  color: #2895eb;\n}\n\n.chat-term-title {\n  margin-top: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #146eb6;\n}\n\n.chat-term-content {\n  margin-top: 10px;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.chat-terms-agree {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px;\n  border-radius: 10px;\n  border: 1px solid #d9d9d9;\n  background: #fafafa;\n}\n\n.chat-terms-agree-description {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.chat-terms-agree-button {\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  color: white;\n  background-color: #2895eb;\n  padding: 7px 20px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.chat-terms-agree-button:hover {\n  background-color: #1886da;\n}\n\n.prompt-examples-container {\n  margin-top: 12px;\n  width: 800px;\n  box-sizing: border-box;\n}\n\n.prompt-examples-title {\n  margin-top: 18px;\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  color: black;\n  line-height: normal;\n}\n\n.prompt-desc {\n  margin-top: 30px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n  width: 800px;\n  text-align: left;\n}\n\n.prompt-examples {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.prompt-example {\n  margin-top: 10px;\n  margin-right: 15px;\n  border-radius: 5px;\n  border: 1px solid #9e9e9e;\n  background: #fff;\n  display: flex;\n  padding: 7px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n\n  font-size: 12px;\n  font-weight: 600;\n  color: #146eb6;\n}\n\n.prompt-example:hover {\n  background-color: #146eb6;\n  color: white;\n}\n\n.chat-content-summary {\n  border-radius: 10px;\n  border: 1px solid #d9d9d9;\n  background: #fafafa;\n  color: black;\n  padding: 30px 20px;\n  margin-top: 20px;\n  width: 800px;\n  box-sizing: border-box;\n}\n\n.btn-tax-calculate {\n  border-radius: 5px !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s !important;\n  color: white !important;\n  background-color: #2895eb !important;\n  /* padding: 7px 20px !important; */\n  /* font-size: 12px !important;\n  font-weight: 600 !important;\n  line-height: normal !important; */\n}\n\n.btn-tax-calculate:hover {\n  background-color: #1886da !important;\n  color: white !important;\n}\n\n.btn-tax-calculate span {\n  color: white !important;\n  margin-right: 8px;\n}\n\n.btn-tax-form-guide {\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  color: white;\n  background-color: #2895eb;\n  padding: 7px 20px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: normal;\n  width: fit-content;\n}\n\n.btn-tax-form-guide:hover {\n  background-color: #1886da;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
